if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-paper-cups-frozen-yogurt-containers") > -1) {
  window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
}
if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-printed-ice-cream-containers-fast") > -1) {
  window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
}
if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-insulated-paper-cups-wholesale") > -1) {
  window.location.href="https://www.custompapercup.com/collections/custom-printed-double-wall-insulated-cups-fast-no-minimum";
}
if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-plastic-cups-wholesale") > -1) {
  window.location.href="https://www.custompapercup.com/collections/custom-printed-clear-cups-fast-no-minimum";
}

// if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-paper-cups-frozen-yogurt-containers") > -1) {
//   window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
// }
// if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-paper-cups-frozen-yogurt-containers") > -1) {
//   window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
// }
// if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-paper-cups-frozen-yogurt-containers") > -1) {
//   window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
// }
// if(window.location.href.indexOf("https://www.custompapercup.com/products/custom-paper-cups-frozen-yogurt-containers") > -1) {
//   window.location.href="https://www.custompapercup.com/collections/custom-printed-ice-cream-containers-fast-no-minimum";
// }  
